import withActDetail from "../withActDetail";
import ActWaterForm from "./ActWaterForm";
import ActWaterPDFGenerator from "./ActWaterPDFGenerator";

const actFormKazakhName = 'Су үлгілерін іріктеу АКТIСI'
const actFormName = 'АКТ отбора образцов воды'
const actFormNumber = '004'
const actName = 'ActWater'

export default withActDetail(ActWaterForm, ActWaterPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)